// extracted by mini-css-extract-plugin
export default {"container":"DoctorList__container--aTtYx"};